import { render } from "./Google2FA.vue?vue&type=template&id=2467abfb&scoped=true"
import script from "./Google2FA.vue?vue&type=script&lang=js"
export * from "./Google2FA.vue?vue&type=script&lang=js"

import "./Google2FA.vue?vue&type=style&index=0&id=2467abfb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2467abfb"

export default script